import { ArrowDropDown } from '@material-ui/icons';
import { withStyles } from '@material-ui/styles';
import cn from 'classnames';
import * as React from 'react';
import { compose, pure } from 'recompose';
import { FontIcon } from '../FontIcon/';
import { ButtonVariants, styles } from './Button';
import { Button, ButtonGroup, ClickAwayListener, Grid, Grow, MenuItem, MenuList, Paper, Popper, } from '@material-ui/core';
const SplitButton = (props) => {
    const { actionOnSelect, classes, classNames, options, title, testId = 'SplitButton' } = props;
    const anchorRef = React.useRef(null);
    const [open, setOpen] = React.useState(false);
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const handleMenuItemClick = React.useCallback((index) => () => {
        if (actionOnSelect) {
            const button = options[index];
            if (button) {
                const { onClick } = button;
                if (onClick) {
                    onClick();
                }
            }
        }
        setSelectedIndex(index);
        setOpen(false);
    }, [actionOnSelect, options, setOpen, setSelectedIndex]);
    const handleToggle = React.useCallback(() => {
        setOpen((prevOpen) => !prevOpen);
    }, [setOpen]);
    const handleClose = React.useCallback((event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    }, [anchorRef, setOpen]);
    const { variant, ...selectedButton } = options[selectedIndex];
    const buttonClasses = cn({
        [classes[variant || ButtonVariants.primary]]: true,
        [classes.flat]: selectedButton.flat,
        [classes.loading]: selectedButton.isLoading,
        [classes.autoWidth]: selectedButton.autoWidth,
        [classes.fullWidth]: selectedButton.fullWidth,
        [classes.isActive]: selectedButton.isActive,
        [classes.rounded]: selectedButton.rounded,
    });
    return (React.createElement(Grid, { alignItems: "center", className: classNames && classNames.container, container: true, direction: "column", "data-testid": `${testId}` },
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(ButtonGroup, { ref: anchorRef, "data-testid": `${testId}-buttonGroup`, "aria-label": "split button" },
                React.createElement(Button, Object.assign({ className: buttonClasses, "data-testid": `${testId}-button` }, selectedButton),
                    options[selectedIndex].iconName && (React.createElement(FontIcon, { "data-testid": `${testId}-icon`, iconName: options[selectedIndex].iconName || '', marginRight: 12, size: options[selectedIndex].iconSize || 14, top: 1, color: options[selectedIndex].iconColor || 'white' })),
                    title || options[selectedIndex].title),
                React.createElement(Button, { "data-testid": `${testId}-toggle`, "aria-controls": open ? 'split-button-menu' : undefined, "aria-expanded": open ? 'true' : undefined, "aria-haspopup": "menu", "aria-label": "select merge strategy", className: buttonClasses, onClick: handleToggle, size: "small" },
                    React.createElement(ArrowDropDown, null))),
            React.createElement(Popper, { anchorEl: anchorRef.current, disablePortal: true, open: open, "transitiondata-testid": `${testId}-popper` }, ({ TransitionProps, placement }) => (React.createElement(Grow, Object.assign({}, TransitionProps, { style: {
                    transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                } }),
                React.createElement(Paper, { className: classNames && classNames.paper },
                    React.createElement(ClickAwayListener, { onClickAway: handleClose },
                        React.createElement(MenuList, { className: classNames && classNames.menu, "data-testid": `${testId}-menu`, id: "split-button-menu" }, options.map((option, index) => (React.createElement(MenuItem, { "data-testid": `${testId}-menuItem`, className: classNames && classNames.menuItem, disabled: option.disabled, key: index, onClick: handleMenuItemClick(index), selected: index === selectedIndex }, option.title))))))))))));
};
const ComposedSplitButton = compose(pure, withStyles(styles, { withTheme: true }))(SplitButton);
ComposedSplitButton.displayName = 'SplitButton';
export default ComposedSplitButton;
//# sourceMappingURL=SplitButton.js.map